"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import { ConfigEarlyWarningFormController } from "@/views/safemanagements/InprogressManager/components/ConfigEarlyWarning.vue";
import AddOrEditTriggerConditionDialog from "@/views/safemanagements/InprogressManager/dialogs/AddOrEditTriggerConditionDialog.vue";
import MembersChooseDialog from "@/views/safemanagements/InprogressManager/dialogs/MembersChooseDialog.vue";
import DepartmentsChooseDialog from "@/views/safemanagements/InprogressManager/dialogs/DepartmentsChooseDialog.vue";
import AddNewWebPageByHandDialog from "@/views/managements/safemanager/dialogs/AddNewWebPageByHand.vue";
import SelectHasWebPageDialog from "@/views/managements/safemanager/dialogs/SelectHasWebPageDialog.vue";
import GroupManageDialog from "@/views/safemanagements/WebResourceManager/components/webResourceDialogs/GroupManagerDialog.vue";
import SelectElementDialog from "@/views/safemanagements/InprogressManager/dialogs/SelectElementDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
let ConfigEarlyRightWarning = class extends Vue {
  constructor() {
    super(...arguments);
    this.handling_measures_members_list = [
      {
        label: this.$t("config_early_warning.form.trigger_condition_all_members"),
        value: "ALL_SUBACCOUNT"
      },
      {
        label: this.$t(
          "config_early_warning.form.trigger_condition_selected_members"
        ),
        value: "USERS"
      },
      {
        label: this.$t(
          "config_early_warning.form.trigger_condition_selected_departments"
        ),
        value: "DEPARTMENT"
      }
    ];
    this.handling_measures_type = "ALL_SUBACCOUNT";
    this.handling_measures_members = [];
    this.empty_image = emptyImage;
  }
  mounted() {
    return __async(this, null, function* () {
      this.initHandlingMeasuresData();
    });
  }
  //
  addResourceFromEnv() {
    return __async(this, null, function* () {
      let datas = [];
      for (let item of this._formController.config_trigger_condition.datas) {
        datas.push({
          id: item.webElementResourceId,
          name: item.name,
          url: item.url
        });
      }
      this._selectHasWebPageDialog.open(datas);
    });
  }
  deleteResource(item) {
    this._formController.config_trigger_condition.datas = _.filter(
      this._formController.config_trigger_condition.datas,
      (data) => {
        return data.webElementResourceId !== item.webElementResourceId;
      }
    );
  }
  //
  addResourceByHand() {
    return __async(this, null, function* () {
      this._addNewWebPageByHandDialog.open();
    });
  }
  // 添加成功
  addByHandSuccess(id) {
    return __async(this, null, function* () {
      try {
        const search_response = yield API.get(
          `api://base.auth/api/v1/web-resources`,
          {
            params: {
              page: 1,
              size: 100,
              search: `id==${id}`
            }
          }
        );
        let searchData = search_response.data.result.datas[0];
        const eventData = {
          events: {
            VISIT_PAGE: true
          },
          type: "webelement",
          webElementResourceId: id,
          name: searchData.name,
          url: searchData.url,
          webElementResourceElements: [],
          webElementResourceElementIds: []
        };
        this._formController.config_trigger_condition["datas"].push(eventData);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //
  selectedWebPages(datas) {
    return __async(this, null, function* () {
      for (let data of datas) {
        let item = _.find(
          this._formController.config_trigger_condition["datas"],
          { webElementResourceId: data.id }
        );
        if (!item) {
          const envData = {
            events: {
              VISIT_PAGE: true
            },
            type: "webelement",
            webElementResourceId: data.id,
            name: data.name,
            url: data.url,
            webElementResourceElements: [],
            webElementResourceElementIds: []
          };
          this._formController.config_trigger_condition["datas"].push(envData);
        }
      }
    });
  }
  // 清空全部网页
  clearAllResource() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("config_early_warning.form.clear_all_resource_tips"),
          this.$t("config_early_warning.form.clear_all_resource_title"),
          {
            confirmButtonText: this.$t(
              "config_early_warning.form.clear_all_resource_confirm"
            ),
            cancelButtonText: this.$t(
              "config_early_warning.form.clear_all_resource_cancel"
            ),
            type: "warning"
          }
        );
        this._formController.config_trigger_condition["datas"] = [];
      } catch (error) {
      }
    });
  }
  //
  openGroupDialog() {
    this._group_manage_dialog.open();
  }
  // 打开元素选择dialog
  openSelectElementDialog(item) {
    this._selectElementDialog.open(item);
  }
  //
  refresh() {
    return __async(this, null, function* () {
      let datas = [];
      for (let item of this._formController.config_trigger_condition.datas) {
        datas.push({
          id: item.webElementResourceId,
          name: item.name,
          url: item.url
        });
      }
      this._selectHasWebPageDialog.open(datas);
    });
  }
  // 选择元素完成
  selectElement(data) {
    let item = _.find(this._formController.config_trigger_condition.datas, {
      webElementResourceId: data.webElementResourceId
    });
    if (item) {
      this.$set(item, "webElementResourceElements", data.selectedIds);
      this.$set(
        item,
        "webElementResourceElementIds",
        _.map(data.selectedIds, "id")
      );
      this.$forceUpdate();
      console.log("\u8BBE\u7F6E\u540E\u7684item:", item);
      console.log(
        "webElementResourceElements:",
        item.webElementResourceElements
      );
    }
  }
  // 初始化处理措施数据的方法
  initHandlingMeasuresData() {
    if (this._formController.handling_measures_type) {
      this.handling_measures_type = this._formController.handling_measures_type;
    }
    if (this._formController.handling_measures_members) {
      this.handling_measures_members = this._formController.handling_measures_members;
    }
  }
  addTriggerCondition() {
    return __async(this, null, function* () {
      this._addOrEditTriggerConditionDialog.open(
        null,
        null,
        this._formController.trigger_type
      );
    });
  }
  changeTriggerCondition(data) {
    if (data.isCreate) {
      if (this._formController.trigger_type === "Amazon_Price_Too_Low") {
        this._formController.system_config_trigger_condition.push({
          triggerCondition: __spreadValues(__spreadValues({
            discount: data.discount,
            price_type: data.price_type
          }, (() => {
            if (data.check_discount === true) {
              return {
                "check_discount": true
              };
            } else {
              return {
                "check_discount": false
              };
            }
          })()), (() => {
            if (data.adjusted_below_total_fees === true) {
              return {
                "adjusted_below_total_fees": true
              };
            } else {
              return {
                "adjusted_below_total_fees": false
              };
            }
          })()),
          shopRange: data.shopRange,
          shops: data.shops
        });
      }
      if (this._formController.trigger_type === "Amazon_Percentage_Off_Too_High" || this._formController.trigger_type === "Amazon_Coupon_Too_High") {
        this._formController.system_config_trigger_condition.push({
          triggerCondition: {
            discount: data.discount
          },
          shopRange: data.shopRange,
          shops: data.shops
        });
      }
      if (this._formController.trigger_type === "Amazon_Goods_Caption_Edit_Too_Frequently" || this._formController.trigger_type === "Amazon_Main_Image_Adjusted_Too_Frequently") {
        this._formController.system_config_trigger_condition.push({
          triggerCondition: {
            days: data.days,
            counts: data.counts
          },
          shopRange: data.shopRange,
          shops: data.shops
        });
      }
    } else {
      let item = _.find(this._formController.system_config_trigger_condition, {
        guid: data.guid
      });
      if (item) {
        if (this._formController.trigger_type === "Amazon_Price_Too_Low") {
          item.triggerCondition.discount = data.discount;
          item.triggerCondition.price_type = data.price_type;
          item.triggerCondition.adjusted_below_total_fees = data.adjusted_below_total_fees;
          item.triggerCondition.check_discount = data.check_discount;
          item.shopRange = data.shopRange;
          item.shops = data.shops;
        }
        if (this._formController.trigger_type === "Amazon_Percentage_Off_Too_High" || this._formController.trigger_type === "Amazon_Coupon_Too_High") {
          item.triggerCondition.discount = data.discount;
          item.shopRange = data.shopRange;
          item.shops = data.shops;
        }
        if (this._formController.trigger_type === "Amazon_Goods_Caption_Edit_Too_Frequently" || this._formController.trigger_type === "Amazon_Main_Image_Adjusted_Too_Frequently") {
          item.triggerCondition.days = data.days;
          item.triggerCondition.counts = data.counts;
          item.shopRange = data.shopRange;
          item.shops = data.shops;
        }
      }
    }
    console.log(this._formController.system_config_trigger_condition);
  }
  editTriggerCondition(item, index) {
    return __async(this, null, function* () {
      this._addOrEditTriggerConditionDialog.open(
        item,
        index,
        this._formController.trigger_type
      );
    });
  }
  deleteTriggerCondition(index) {
    return __async(this, null, function* () {
      this._formController.system_config_trigger_condition.splice(index, 1);
    });
  }
  saveUsers(data) {
    return __async(this, null, function* () {
      try {
        this.handling_measures_type = "USERS";
        this.handling_measures_members = data;
        this._formController.handling_measures_type = "USERS";
        this._formController.handling_measures_members = data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeDepartments(data) {
    return __async(this, null, function* () {
      try {
        this.handling_measures_type = "DEPARTMENT";
        this.handling_measures_members = data;
        this._formController.handling_measures_type = "DEPARTMENT";
        this._formController.handling_measures_members = data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDepartments() {
    this.handling_measures_type = this._formController.handling_measures_type;
    this.handling_measures_members = this._formController.handling_measures_members;
  }
  closeMembers() {
    this.handling_measures_type = this._formController.handling_measures_type;
    this.handling_measures_members = this._formController.handling_measures_members;
  }
  openMembersChooseDialog() {
    this._memebersChooseDialog.open(this.handling_measures_members);
  }
  openDepartmentsChooseDialog() {
    this._departmentsChooseDialog.open(this.handling_measures_members);
  }
  checkChangeHandlingMeasuresType(data) {
    return __async(this, null, function* () {
      if (this.handling_measures_type === "ALL_SUBACCOUNT") {
        this.handling_measures_type = "ALL_SUBACCOUNT";
        this._formController.handling_measures_type = "ALL_SUBACCOUNT";
        this.handling_measures_members = [];
        this._formController.handling_measures_members = [];
      }
      if (this.handling_measures_type === "USERS" && this._formController.handling_measures_type === "USERS") {
        this._memebersChooseDialog.open(
          this._formController.handling_measures_members
        );
      }
      if (this.handling_measures_type === "USERS" && this._formController.handling_measures_type !== "USERS") {
        this._memebersChooseDialog.open([]);
      }
      if (this.handling_measures_type === "DEPARTMENT" && this._formController.handling_measures_type === "DEPARTMENT") {
        this._departmentsChooseDialog.open(
          this._formController.handling_measures_members
        );
      }
      if (this.handling_measures_type === "DEPARTMENT" && this._formController.handling_measures_type !== "DEPARTMENT") {
        this._departmentsChooseDialog.open([]);
      }
    });
  }
};
__decorateClass([
  PropSync("formController", {
    type: Object,
    default: () => new ConfigEarlyWarningFormController()
  })
], ConfigEarlyRightWarning.prototype, "_formController", 2);
__decorateClass([
  PropSync("warningType", {
    type: String,
    default: () => "config"
  })
], ConfigEarlyRightWarning.prototype, "_warningType", 2);
__decorateClass([
  Ref("selectElementDialog")
], ConfigEarlyRightWarning.prototype, "_selectElementDialog", 2);
__decorateClass([
  Ref("addNewWebPageByHandDialog")
], ConfigEarlyRightWarning.prototype, "_addNewWebPageByHandDialog", 2);
__decorateClass([
  Ref("addOrEditTriggerConditionDialog")
], ConfigEarlyRightWarning.prototype, "_addOrEditTriggerConditionDialog", 2);
__decorateClass([
  Ref("membersChooseDialog")
], ConfigEarlyRightWarning.prototype, "_memebersChooseDialog", 2);
__decorateClass([
  Ref("departmentsChooseDialog")
], ConfigEarlyRightWarning.prototype, "_departmentsChooseDialog", 2);
__decorateClass([
  Ref("selectHasWebPageDialog")
], ConfigEarlyRightWarning.prototype, "_selectHasWebPageDialog", 2);
__decorateClass([
  Ref("groupManageDialog")
], ConfigEarlyRightWarning.prototype, "_group_manage_dialog", 2);
ConfigEarlyRightWarning = __decorateClass([
  Component({
    components: {
      AddOrEditTriggerConditionDialog,
      MembersChooseDialog,
      DepartmentsChooseDialog,
      AddNewWebPageByHandDialog,
      SelectHasWebPageDialog,
      GroupManageDialog,
      SelectElementDialog
    },
    watch: {
      // 监听 _formController.handling_measures_type 的变化
      "_formController.handling_measures_type": {
        handler(newVal) {
          if (newVal) {
            this.$set(this, "handling_measures_type", newVal);
          }
        },
        immediate: true
      },
      // 监听 _formController.handling_measures_members 的变化
      "_formController.handling_measures_members": {
        handler(newVal) {
          if (newVal) {
            this.$set(this, "handling_measures_members", newVal);
          }
        },
        immediate: true
      }
    }
  })
], ConfigEarlyRightWarning);
export {
  ConfigEarlyRightWarning as default
};
